import axios from '@/api/axios';

/**
 * Sends stripe token to the backend
 * @param token - stripe payment method token
 * @param headers - auth headers
 * @returns {*}
 */
function chargeOrder({ token, orderId, headers = {} }) {
  return axios.put(`/api/v1/orders/${orderId}/payment/`, { token }, headers);
}

export default {
  chargeOrder,
};



// WEBPACK FOOTER //
// ./src/apps/kiosk/api/index.js